import './ImageDetection.css';
import ImageCompressor from './ImageCompressor';

export function ImageDetection() {
  return (
    <div>
      <div className="mt-16 flex flex-row justify-center">
        <ImageCompressor />
      </div>
    </div>
  );
}
